import { render, staticRenderFns } from "./Stand.vue?vue&type=template&id=587977d4&scoped=true&"
import script from "./Stand.vue?vue&type=script&lang=js&"
export * from "./Stand.vue?vue&type=script&lang=js&"
import style0 from "./Stand.vue?vue&type=style&index=0&id=587977d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587977d4",
  null
  
)

export default component.exports